/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";
import {
  Button, 
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import compose from "recompose/compose";
import range from 'lodash-es/range';
import ReactBSAlert from "react-bootstrap-sweetalert";
import ImageGallery from "react-image-gallery";
import {isMobile} from 'react-device-detect';

import DocumentAnalysisHeader from "components/Headers/DocumentAnalysisHeader.jsx";
import { 
  crudGetOneById as crudGetOneByIdAction,
} from 'store/actions/dataActions';
import { 
  showNotification as showNotificationAction
} from 'store/actions/notificationActions';
import { downloadFile } from 'util/common';
import { 
  SAMPLE_FILE_BTN_COLORS,
  SPIKE_PDFion_PREVIEW_IMAGE_INFO,
  DOCUMENT_ANALYSIS_SAMPLE_DOWNLOAD_NAME,
  DOCUMENT_ANALYSIS_SAMPLE_DOWNLOAD_PATH,
} from 'util/constants';


class DocumentAnalysis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      previewImages: null,
    };
  }

  onHidePreview = (event) => {
    this.setState({
      previewImages: null,
    });
  };

  onPreviewSampleFile = (previewNo) => (event) => {
    if( previewNo && previewNo > 0 ) {
      this.setState({
        previewImages: SPIKE_PDFion_PREVIEW_IMAGE_INFO[previewNo-1]
      });
    }
  }

  onAnalysisSampleFile = (no) => (event) => {
    this.props.dispatchCrudGetOneById(this.props.menu+".SAMPLE", no);
  }

  // 샘플파일 다운로드
  onDownloadSampleFile = event => {
    event.stopPropagation();
    downloadFile(DOCUMENT_ANALYSIS_SAMPLE_DOWNLOAD_PATH, DOCUMENT_ANALYSIS_SAMPLE_DOWNLOAD_NAME, "isDownloadingSampleFile", this, this.props.dispatchShowNotification)
  }

  // 분석 결과 파일 다운로드버튼 클릭
  onDownloadResultFile = () => {
    const downloadUrl = this.props.item && this.props.item.fileDownloadUrl;
    const filename = this.props.item && this.props.item.fileName;
    downloadFile(downloadUrl, filename, "isDownloadingResultFile", this, this.props.dispatchShowNotification)
  }
  
  render() {
    const { menu, item } = this.props;
    const { isDownloadingResultFile, isDownloadingSampleFile, previewImages } = this.state;
    const sampleFileCnt = SPIKE_PDFion_PREVIEW_IMAGE_INFO.length;

    return (
      <>
        <DocumentAnalysisHeader menu={menu} />
        { previewImages && previewImages.length > 0 && <ReactBSAlert
          custom
          title="Preview"
          onConfirm={this.onHidePreview}
          customButtons={
            <Button
              color="primary"
              onClick={this.onHidePreview}
            >
            닫기
            </Button>
          }
        >
          <ImageGallery 
            showThumbnails={false}
            infinite={false}
            showIndex={true}
            lazyLoad={true}
            showFullscreenButton={isMobile ? false : true}
            //showPlayButton={false}
            items={previewImages}
          />
        </ReactBSAlert> }

        <Container className=" mt--7" fluid>
          { item && (
            <Row>
              <div className=" col">
                <Card className=" shadow">
                  <CardHeader className="bg-transparent">
                    <Row className="align-items-center">
                      <div className="col">
                        <h6 className="text-uppercase ls-1 mb-1 gray-600">
                          Overview
                        </h6>
                        <h2 className=" mb-0">문서 내용</h2>
                      </div>
                      { item.fileDownloadUrl && item.fileName ?  (
                        <div className="col text-right">
                          <Button
                            color="primary"
                            disabled={ isDownloadingResultFile ? true : false }
                            onClick={this.onDownloadResultFile}
                          >
                            <span className="btn-inner--icon">
                              { isDownloadingResultFile ? <Spinner size="sm" color="light" /> : null }
                            </span>
                            <span className="btn-inner--text">분석 파일 다운로드</span>
                          </Button>
                        </div>
                      ) : null }
                    </Row>
                  </CardHeader>
                  <CardBody>
                    {/* 문서 내용 */}
                    <pre className="document-overview">
                      {item.content}
                    </pre>
                  </CardBody>
                </Card>
              </div>
            </Row>
          )}

          <Row className={ item ? "mt-5" : ""}>
            <Col className="mb-5 mb-xl-0" xl="8">
              <Card className="shadow">
                <CardHeader className="bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h6 className="text-uppercase text-light ls-1 mb-1">
                        TEST
                      </h6>
                      <h2 className="mb-0">샘플파일로 테스트</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody className="text-center">
                  { range(1, sampleFileCnt+1).map((no) => {
                    const color = SAMPLE_FILE_BTN_COLORS[no%(SAMPLE_FILE_BTN_COLORS.length)];
                    return (
                      <React.Fragment key={`sample${no}`}>
                        <Button
                          color={color}
                          className="mb-1"
                          onClick={this.onPreviewSampleFile(no)}
                        >
                          샘플파일{no} (PDF) 미리보기
                        </Button>
                        <Button
                          outline
                          color={color}
                          className="mb-1"
                          onClick={this.onAnalysisSampleFile(no)}
                        >
                          샘플파일{no} (PDF) 분석하기
                        </Button>
                        <hr className="mt-2 mb-2" />
                      </React.Fragment>
                    );
                  })}
                </CardBody>
              </Card>
            </Col>
            <Col xl="4">
              <Card className="shadow">
                <CardHeader className="bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h6 className="text-uppercase text-muted ls-1 mb-1">
                        DOWNLOAD
                      </h6>
                      <h2 className="mb-0">샘플파일 다운로드</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row className="align-items-center">
                    <div className="col text-center">
                      <Button
                        color="primary"
                        disabled={ isDownloadingSampleFile ? true : false }
                        onClick={this.onDownloadSampleFile}
                      >
                        <span className="btn-inner--icon">
                          { isDownloadingSampleFile ? <Spinner size="sm" color="light" /> : null }
                        </span>
                        <span className="btn-inner--text">샘플파일을 다운받아 업로드해보세요</span>
                      </Button>
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default compose(
  connect(
    ( state, props ) => ({
      item: state.main.item,
    }), {
      dispatchCrudGetOneById: crudGetOneByIdAction,
      dispatchShowNotification: showNotificationAction,
    }
  ),
)(DocumentAnalysis);

DocumentAnalysis.propTypes = {
  menu: PropTypes.string.isRequired,
};